import { render, staticRenderFns } from "./ContentLabels.vue?vue&type=template&id=40702dbc&scoped=true"
import script from "./ContentLabels.vue?vue&type=script&lang=js"
export * from "./ContentLabels.vue?vue&type=script&lang=js"
import style0 from "./ContentLabels.vue?vue&type=style&index=0&id=40702dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40702dbc",
  null
  
)

export default component.exports